import _ from "app/lang";
import Device from "app/models/Device";

import { DrawerMenuItem } from "../DrawerMenu";

export default function (baseUrl: string, device: Device): DrawerMenuItem[] {
    const items: DrawerMenuItem[] = [
        {
            icon: "dashboard",
            text: _("Dashboard"),
            href: `${baseUrl}/dashboard`
        },
        device.configType === "DoorLock" ? {
            icon: "multiline_chart",
            text: _("Statistics"),
            href: `${baseUrl}/statistics`
        } : {
            icon: "multiline_chart",
            text: _("Statistics"),
            subitems: [
                {
                    icon: "wifi",
                    text: _("Wireless"),
                    href: `${baseUrl}/wireless`
                },
                {
                    icon: "pie_chart",
                    text: _("System"),
                    href: `${baseUrl}/system`
                }
            ]
        }
    ];

    // ECCLOUD-8933: temporarily hide Clients page for Pi7
    if (device.supportsClients && device.configType !== "Pi7") {
        items.push({
            icon: "signal_wifi_3_bar",
            text: _("Clients"),
            href: `${baseUrl}/clients`
        });
    }

    items.push({
        icon: "list_alt",
        text: _("Activity"),
        href: `${baseUrl}/activity`
    });

    return items;
}
